import React, { Ref } from 'react';

// helpers
import { FormikHelpers, FormikProps } from 'formik';
import { IdentificationStepForOrganizationShortValidationSchema } from 'validations/onboarding-new/identification';

// components
import { Form } from '@ui';
import InnerForm from './InnerForm';
import HideIfDisabledForm from '../../../HideIfDisabledForm';
import SubmitButtons, {
  SubmitButtonsFormValuesModel,
} from '../Components/SubmitButtons';

interface IProps {
  formRef?: Ref<FormikProps<FormValuesModel>>;
  initialFormValues: FormValuesModel;
  onSubmit: (
    values: FormValuesModel,
    helpers: FormikHelpers<FormValuesModel>,
  ) => Promise<void>;

  disabled?: boolean;
  showOnlySaveButton?: boolean;
}

export interface FormValuesModel extends SubmitButtonsFormValuesModel {
  isRegulated: boolean | null;
  regulationCountry: string[];
}

const IdentificationForOrganizationShortForm = ({
  formRef,
  initialFormValues,
  onSubmit,
  showOnlySaveButton,
  disabled,
}: IProps) => {
  return (
    <Form<FormValuesModel>
      enableReinitialize
      confirmExitWithoutSaving
      innerRef={formRef}
      onSubmit={onSubmit}
      disabled={disabled}
      initialValues={initialFormValues}
      validationSchema={IdentificationStepForOrganizationShortValidationSchema}
      renderForm={
        <>
          <InnerForm />
          <HideIfDisabledForm>
            <SubmitButtons showOnlySaveButton={showOnlySaveButton} />
          </HideIfDisabledForm>
        </>
      }
    />
  );
};

export default IdentificationForOrganizationShortForm;
